import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox, FDEmptyState, FDPaper, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import {
  BalanceSheetCategoryAccordion,
} from 'Views/Page/Content/Templates/HouseholdBalanceSheetPageTemplate/BalanceSheetCategoryAccordion';

export const BalanceSheetCategoriesAccordion = ({
  categoriesCollection,
  onEditLineItemClick,
  isEmpty,
  emptyTitle,
  emptyDescription,
  expandedCategoryIDs,
  setExpandedCategoryIDs,
  hasBigNumbers,
  isFiltering,
  overrideEmptyState,
}) => {
  const mainContent = (
    <FDStack direction="column" spacing={2}>
      {categoriesCollection.resources().list().map((categoryResource) => (
        <BalanceSheetCategoryAccordion
          key={categoryResource.id()}
          hasBigNumbers={hasBigNumbers}
          expanded={expandedCategoryIDs.has(categoryResource.id())}
          setExpanded={(shouldBeExpanded) => setExpandedCategoryIDs((oldSet) => {
            // Make a brand new copy of the set so that react this is a change
            const newSet = new Set(oldSet);
            if (shouldBeExpanded) {
              newSet.add(categoryResource.id());
              return newSet;
            }
            newSet.delete(categoryResource.id());
            return newSet;
          })}
          categoryResource={categoryResource}
          onEditLineItemClick={onEditLineItemClick}
          isFiltering={isFiltering}
        />
      ))}
    </FDStack>
  );

  // If the overrideEmptyState prop is set, we will not show the empty state, but instead show the main content
  if (overrideEmptyState) {
    return mainContent;
  }

  return (
    <>
      {isEmpty ? (
        <FDPaper padding={2} appearance="flat">
          <FDBox flex={1} paddingY={2}>
            <FDEmptyState
              icon={'search'}
              title={emptyTitle}
              description={emptyDescription}
              {...dataAttrs('balance-sheet-empty-section')}
            />
          </FDBox>
        </FDPaper>
      ) : mainContent}
    </>
  );
};

BalanceSheetCategoriesAccordion.propTypes = {
  expandedCategoryIDs: PropTypes.object.isRequired,
  setExpandedCategoryIDs: PropTypes.func.isRequired,
  categoriesCollection: PropTypes.object.isRequired,
  onEditLineItemClick: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  emptyTitle: PropTypes.string.isRequired,
  emptyDescription: PropTypes.string.isRequired,
  hasBigNumbers: PropTypes.bool.isRequired,
  isFiltering: PropTypes.bool.isRequired,
  overrideEmptyState: PropTypes.bool,
};
